import { Icon, Space } from '@sravni/react-design-system';

import type { Badge } from 'commonTypes/api/scenarios/BaseTypes';

export const modifyBadges = (badges: Badge[]): any[] =>
  badges?.map((badge) => {
    if (badge.icon) {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const DetailIcon = require('@sravni/react-icons')[badge.icon || 'Fire'];
      return {
        ...badge,
        variant: badge.type,
        text: (
          <Space
            size={4}
            align="center"
          >
            {badge.title}
            <Icon
              size={16}
              icon={<DetailIcon />}
            />
          </Space>
        ),
      };
    }

    return { ...badge, variant: badge.type, text: badge.title };
  });
